<div class="flex h-full flex-col">
  <div class="bg-m0 flex flex-grow overflow-y-auto rounded shadow">
    <div class="divide-s500 ml-5 mr-5 mt-14 flex w-full flex-col divide-y">
      <div
        class="text-s1 mb-3 mr-5 flex h-6 flex-row space-x-5 text-base font-semibold"
      >
        <div class="flex w-12"></div>
        <div class="flex w-1/4">Report</div>
        <div class="flex flex-1 flex-row space-x-5">
          <div class="flex flex-1">Report Id</div>
          <div class="flex flex-1">Space</div>
          <div class="flex flex-1">Access Roles</div>
          <div class="flex flex-1">Author</div>
        </div>
      </div>

      <div
        *ngIf="filteredReports?.length > 0"
        class="h-2 flex-1 overflow-y-auto"
      >
        <div
          *ngFor="
            let item of filteredReports;
            let i = index;
            trackBy: trackByFn
          "
          class="hover:bg-m50 bg-m0 flex flex-row hover:cursor-pointer"
          [ngStyle]="
            item.reportId !==
              filteredReports[filteredReports.length - 1].reportId && {
              'border-bottom-width': '1px'
            }
          "
          [ngClass]="{
            'mt-2': i === 0,
            'mb-5': i === filteredReports.length - 1,
            'border-s300':
              item.reportId !==
              filteredReports[filteredReports.length - 1].reportId
          }"
        >
          <div class="flex-grow flex-col text-base">
            <div
              class="text-s1 group mr-5 flex w-full flex-row items-start space-x-5 rounded pt-1 focus:outline-none"
              (click)="navigateToReport(item.reportId)"
            >
              <div class="flex w-12 pl-3">
                <div class="invisible flex group-hover:visible">
                  <m-report-options
                    [reportUnit]="item"
                    [isHoverM]="false"
                  ></m-report-options>
                </div>
              </div>

              <div class="flex w-1/4 select-none truncate pb-[9px] pt-[7px]">
                <span class="select-none truncate">
                  {{ !!item.title ? (item.title | capitalize) : item.reportId }}
                </span>
              </div>

              <div class="flex flex-1 flex-row space-x-5 text-base">
                <div
                  class="flex flex-1 items-start truncate pb-[9px] pt-[7px] focus:outline-none"
                >
                  <span class="truncate"> {{ item.reportId }} </span>
                </div>

                <div
                  class="flex flex-1 items-start truncate pb-[9px] pt-[7px] focus:outline-none"
                >
                  <span class="truncate">
                    {{ item.spaceFullTitle }}
                  </span>
                </div>

                <div
                  class="flex flex-1 flex-wrap truncate pb-[9px] pt-[7px] text-base"
                >
                  <span
                    *ngFor="let accessRole of item.accessRolesCombined"
                    class="mr-2 truncate rounded px-2"
                    [ngClass]="{
                      'bg-green-200 text-green-700': accessRole.isDirect,
                      'bg-slate-200 text-slate-700': !accessRole.isDirect
                    }"
                  >
                    {{ accessRole.role }}
                  </span>
                </div>

                <div
                  class="flex flex-1 items-start truncate pb-[9px] pt-[7px] focus:outline-none"
                >
                  <span>
                    {{ item.author }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="h-11"></div>
        </div>
      </div>

      <div
        class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
        *ngIf="filteredReports?.length === 0"
        >Reports are empty</div
      >
    </div>
  </div>
</div>

<div *ngIf="nav$ | async"></div>
<!-- <div *ngIf="isExplorer$ | async"></div> -->
<div *ngIf="filteredReports$ | async"></div>
